import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

const userSettingsTranslationRef = createTranslationRef({
  id: "user-settings",
  messages: {
    languageToggle: {
      title: "Language",
      description: "Change the language",
      select: "Select language {{language}}"
    },
    themeToggle: {
      title: "Theme",
      description: "Change the theme mode",
      select: "Select theme {{theme}}",
      selectAuto: "Select Auto Theme",
      names: {
        light: "Light",
        dark: "Dark",
        auto: "Auto"
      }
    }
  }
});

export { userSettingsTranslationRef };
//# sourceMappingURL=translation.esm.js.map
